/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantRelationshipDto } from './TenantRelationshipDto';
import {
    TenantRelationshipDtoFromJSON,
    TenantRelationshipDtoFromJSONTyped,
    TenantRelationshipDtoToJSON,
    TenantRelationshipDtoToJSONTyped,
} from './TenantRelationshipDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Response containing a list of tenant relationships
 * @export
 * @interface TenantRelationshipListResponse
 */
export interface TenantRelationshipListResponse {
    /**
     * List of tenant relationships
     * @type {Array<TenantRelationshipDto>}
     * @memberof TenantRelationshipListResponse
     */
    relationships?: Array<TenantRelationshipDto>;
    /**
     * Total number of relationships
     * @type {number}
     * @memberof TenantRelationshipListResponse
     */
    total?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof TenantRelationshipListResponse
     */
    page?: number;
    /**
     * Number of relationships per page
     * @type {number}
     * @memberof TenantRelationshipListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantRelationshipListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantRelationshipListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantRelationshipListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantRelationshipListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the TenantRelationshipListResponse interface.
 */
export function instanceOfTenantRelationshipListResponse(value: object): value is TenantRelationshipListResponse {
    return true;
}

export function TenantRelationshipListResponseFromJSON(json: any): TenantRelationshipListResponse {
    return TenantRelationshipListResponseFromJSONTyped(json, false);
}

export function TenantRelationshipListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantRelationshipListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'relationships': json['relationships'] == null ? undefined : ((json['relationships'] as Array<any>).map(TenantRelationshipDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function TenantRelationshipListResponseToJSON(json: any): TenantRelationshipListResponse {
    return TenantRelationshipListResponseToJSONTyped(json, false);
}

export function TenantRelationshipListResponseToJSONTyped(value?: TenantRelationshipListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationships': value['relationships'] == null ? undefined : ((value['relationships'] as Array<any>).map(TenantRelationshipDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

